module.exports = __webpack_public_path__ + "img/05.08e322d9.png";